/* eslint-disable @typescript-eslint/no-unused-vars */
import { getCachedAuthInfo } from "../services/backend-api";

type Roles = ["member", "admin", "tester", "editor", "translator", "tier_1", "tier_2", "tier_3"];
export type UserRole = Roles[number];
export type Attributes = "all" | "preview_features" | "translate" | "edit_site_data" | "subscribe_item";

// TODO: fetch roleDefs from backend, but only return data for the user's roles
const roleDefinitions: Record<Roles[number], undefined | Partial<Record<Attributes, boolean>>> = {
  admin: { all: true },
  member: {},
  tester: { preview_features: true },
  editor: { edit_site_data: true },
  translator: { translate: true },
  tier_1: { subscribe_item: true, preview_features: true },
  tier_2: { subscribe_item: true, preview_features: true },
  tier_3: { subscribe_item: true, preview_features: true, edit_site_data: true },
};

// TODO: turn this into a hook, useAuthContext and compute permissions once
class PermissionManager {
  private getUserRoles() {
    return getCachedAuthInfo().roles || []; // TODO: cache this, cuz currently it gets from localstorage and decrypt everytime
  }

  userCanAccess(attrib: Attributes) {
    const userRoles = this.getUserRoles();
    for (const role of userRoles) {
      if (roleDefinitions[role]?.all) return true;
      if (roleDefinitions[role]?.[attrib]) return true;
    }
    return false;
  }
}

const permissionManager = new PermissionManager();

export default permissionManager;
